import { LitElement, nothing } from 'lit';
import { customElement } from 'lit/decorators.js';
import { clearSignupFlowMarkers, determineSignupFlow, hasSignupSubmitted } from './signup-flow.logic';

export const SIGNUP_COMPLETE_EVENT = 'kd_signup_complete';

interface DataLayerWindow extends Window {
  dataLayer?: Record<string, unknown>[];
}

/**
 * 会員登録完了イベント送信
 *
 * @element kd-signup-flow-complete
 * @description 会員登録完了ページで導線種別（signup_flow）を判定し、
 *              GTM の dataLayer に kd_signup_complete イベントとして push する。
 *              登録フォームの送信済みマーカーがある場合のみ送信し、既存会員のリダイレクト・再訪・リロードでは送信しない。
 *              送信後は sessionStorage の記録を削除し、次のセッションへ持ち越さない。
 */
@customElement('kd-signup-flow-complete')
export class KdSignupFlowComplete extends LitElement {
  createRenderRoot() {
    return this;
  }

  connectedCallback(): void {
    super.connectedCallback();
    this.sendSignupComplete();
  }

  private sendSignupComplete(): void {
    if (!hasSignupSubmitted()) return;

    const signupFlow = determineSignupFlow();

    const win = window as DataLayerWindow;
    win.dataLayer = win.dataLayer || [];
    win.dataLayer.push({
      event: SIGNUP_COMPLETE_EVENT,
      signup_flow: signupFlow,
    });

    clearSignupFlowMarkers();
  }

  render() {
    return nothing;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'kd-signup-flow-complete': KdSignupFlowComplete;
  }
}
